module.exports = "<span [ngClass]=\"setColor()\">{{timer | async | date:'m:ss'}}</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/visbos-core/components/timer/timer.component.html
// module id = ./src/app/core/visbos-core/components/timer/timer.component.html
// module chunks = main